'use client';

import { Checkbox } from '@magicschool/spellbook/components/Checkbox';

export interface SelectRowCheckboxProps {
  label: string;
  onToggle: () => void;
  checked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
}

export function SelectRowCheckbox({ label, onToggle, checked, indeterminate, disabled }: SelectRowCheckboxProps) {
  return (
    <Checkbox
      label={label}
      showLabel={false}
      checked={indeterminate ? 'indeterminate' : checked}
      onCheckedChange={onToggle}
      disabled={disabled}
    />
  );
}
